import { DatePicker, Form, Input, Select } from 'antd';
import { FormInstance } from 'antd/es/form/hooks/useForm';
import { useTranslation } from 'translations/hooks';

import { UpdateRepairFormValues } from './types';

interface FormOption {
  label: string;
  value: string;
}

interface UpdateRepairFormProps {
  form: FormInstance<UpdateRepairFormValues>;
  save: (row: UpdateRepairFormValues) => void;
  initialValues: UpdateRepairFormValues;
  typeOptions: FormOption[];
  loading: boolean;
}

export const UpdateRepairForm: React.FC<UpdateRepairFormProps> = ({
  form,
  save,
  initialValues,
  typeOptions,
  loading,
}) => {
  const { t } = useTranslation();

  return (
    <Form<UpdateRepairFormValues>
      form={form}
      layout="vertical"
      onFinish={save}
      initialValues={initialValues}
    >
      <Form.Item<UpdateRepairFormValues>
        name="date"
        label={t('qualityControl.segmentHistory.drawer.defectModal.dateLabel')}
        rules={[{ required: true }]}
      >
        <DatePicker
          style={{ width: '100%' }}
          showTime={{ format: 'HH:mm' }}
          format="L HH:mm"
          allowClear={false}
        />
      </Form.Item>
      <Form.Item<UpdateRepairFormValues>
        name="type"
        label={t('qualityControl.segmentHistory.drawer.details.type_repair')}
        rules={[{ required: true }]}
      >
        <Select options={typeOptions} allowClear={false} loading={loading} />
      </Form.Item>
      <Form.Item<UpdateRepairFormValues>
        name="description"
        label={t('qualityControl.segmentHistory.drawer.details.comment')}
        rules={[{ required: true }]}
      >
        <Input />
      </Form.Item>
    </Form>
  );
};
